<template>
    <div class="w-head">
        <div class="w-head-container">
            <div class="w-head-left">
                <ul>
                    <li v-for="menu in menus" :key="menu.id" @click="selecMenu(menu)">
                        <span>{{menu.title}}</span>
                    </li>
                </ul>
            </div>
            <div class="w-head-right">
                <div class="w-head-regist w-float-right">
                    <div @click="registUser">注册</div>  
                </div>
                <div class="w-head-logout w-float-right">
                    <div @click="logo">{{userInfo.userId==undefined?'登录':'退出'}}</div>
                </div>
                <div class="w-head-nickname w-float-right" :title="userInfo.userName==undefined?'':userInfo.userName+',欢迎您！'" @click="gotoManage">
                    [{{userInfo.userName==undefined?'你还未登录':userInfo.userName}}]
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            menus:[{
                id:'1',
                title:'首页',
                url:'/Wisdom/user/index.htm'
            },{
                id:'2',
                title:'下载资源',
                url:'/Wisdom/category/getAllCategoryFile.htm'
            },{
                id:'3',
                title:'电子书',
                url:'/Wisdom/ebook/queryPageEbook.htm'
            },{
                id:'4',
                title:'Jar包集',
                url:'/Wisdom/jar/queryPageJar.htm'
            },{
                id:'5',
                title:'关于我们',
                url:''
            },{
                id:'6',
                title:'联系我们',
                url:''
            }],
            userInfo:{
                userId:undefined
            }
        }
    },
    methods:{
        getUserInfo(){
            /**
             * 获取登录用户信息
             */
            var that=this;
            var params =  this.$Qs.stringify({
            });
            this.$Axios.post('/Wisdom/user/getLoginUserInfo.htm',params).then((res)=>{
                var data=res.data;
                if(data.code=='0'){
                    that.userInfo=data.data;
                }
                
            }).catch((error)=>{
                that.$message.error(error);
            });
        },
        logout(){
            /**
             * 退出登录
             */
            var that=this;
            var params =  this.$Qs.stringify({
            });
            this.$Axios.post('/Wisdom/user/logout.htm',params).then((res)=>{
                var data=res.data;
                if(data.code==0){
                    window.location.href="/Wisdom/user/index.htm";
                }else if(data.code==0){
                    that.$message.error(data.desc);
                }
            }).catch((error)=>{
                that.$message.error(error);
            });
        },
        selecMenu(menu){
            if(menu.id=='5'||menu.id=='6'){
                this.$message.info("敬请期待！");
            }else{
                window.location.href=menu.url;
            }
        },
        registUser(){
            window.location.href="/Wisdom/user/logo.htm";
        },
        logo(){
            if(this.userInfo.userId==undefined){
                var params =  this.$Qs.stringify({
                    urlPageLocation:window.location.href
                });
                this.$Axios.post('/Wisdom/user/getPageLocation.htm',params).then((res)=>{
                    window.location.href="/Wisdom/user/logo.htm";
                }).catch(function(error){
                    window.location.href="/Wisdom/user/logo.htm";
                });
            }else{
                this.$confirm('确定退出该网站？', '提示', {
                    confirmButtonText: '退出',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    this.logout();
                });
            }
            
        },
        gotoManage(){
            if(this.userInfo.userId!=undefined){
                window.location.href="/Wisdom/user/manage.htm?linkType=person";
            }
        }
    },
    mounted(){
        this.getUserInfo();
    }
}
</script>
<style scoped>
.w-head{
    width: 100%;
    height: 80px;
    line-height: 80px;
    background:rgba(0, 0, 0, 0.6);
}
.w-head-container{
    width: calc(100% - 50px);
    height: 100%;
    margin-left: 50px;
}
.w-head-left{
    width: 70%;
    height: 100%;
    float: left;
}
.w-head-right{
    width: 30%;
    height: 100%;
    float: left;
}
.w-head-left ul{
    margin: 0;
    padding: 0;
    height: 80px;
    list-style: none;
}
.w-head-left ul li{
    float: left;
    margin-right: 60px;
    cursor: pointer;
}
.w-head-left ul li span{
    display: block;
    height: 80px;
    line-height: 80px;
    font-size: 16px;
    color:white;
}
.w-float-right{
    float: right;
    margin:0 5px 0 5px;
    font-size: 14px;
    color:white;
}
.w-float-right div{
    font-size: 14px;
}
.w-head-regist{
    margin-right: 20px;
    cursor: pointer;
}
.w-head-logout{
    cursor: pointer;
}

</style>    



// WEBPACK FOOTER //
// src/components/Head.vue